exports = module.exports = require("../../../../../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-processingMessage__root--3HZuW{color:#88898c;display:block;font-size:11px;margin:5px 0 0;text-align:right}.besidaMob-processingMessage__textRed--2nhT8{color:#ce0000}.besidaMob-processingMessage__textBlue--2HVyu{color:#0670eb;cursor:pointer}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-processingMessage__root--3HZuW",
	"textRed": "besidaMob-processingMessage__textRed--2nhT8",
	"textBlue": "besidaMob-processingMessage__textBlue--2HVyu"
};